module.exports = __webpack_public_path__ + "static/logo-kts-footer-87cfdb8b3712043e93d91b071d7160bd.png";